import { MutationTree } from 'vuex';
import { Direction, IRootState, MutationTypes } from './types';

const mutations: MutationTree<IRootState> = {
  [MutationTypes.SET_LOCALE](state, locale: string) {
    state.locale = locale;
  },

  [MutationTypes.MODULE_REGISTERED](state, moduleName: string) {
    state.registeredModules = [...state.registeredModules, moduleName];
  },

  [MutationTypes.SET_DIRECTION](state, direction: Direction) {
    state.direction = direction;
  },

  [MutationTypes.SET_HIDE_IGENTIFY_LOGO](state, hideIgentifyLogo: boolean) {
    state.hideIgentifyLogo = hideIgentifyLogo;
  },

  [MutationTypes.SET_IS_LOGGED_IN](state, isLoggedIn: boolean) {
    state.isLoggedIn = isLoggedIn;
  },

  [MutationTypes.SET_SUPOORTS_LANDSCAPE_WARNING](state, supportsLandscapeWarning: boolean) {
    state.supportsLandscapeWarning = supportsLandscapeWarning;
  },
};

export default mutations;
